import { render, staticRenderFns } from "./ReviewPage.vue?vue&type=template&id=456d0f0b&scoped=true"
import script from "./ReviewPage.vue?vue&type=script&lang=ts"
export * from "./ReviewPage.vue?vue&type=script&lang=ts"
import style0 from "./ReviewPage.vue?vue&type=style&index=0&id=456d0f0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "456d0f0b",
  null
  
)

export default component.exports